import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { analyticsLocalStorage } from '.';

export default ({ courseId, userId, timeZone }) => {
  const existingEntry = analyticsLocalStorage.findExistingEntry({
    type: 'courseAccess',
    userId
  });

  const data = existingEntry ? existingEntry.values.data : [];

  const zonedDate = toZonedTime(Date.now(), timeZone);
  const date = `${format(zonedDate, 'y-MM-dd')}T${format(zonedDate, 'HH')}`;

  const entryExists = data.find((entry) => {
    return entry.date === date && entry.courseId === courseId;
  });
  if (!entryExists) data.push({ courseId, date });

  analyticsLocalStorage.createOrUpdateEntry({
    key: existingEntry ? existingEntry.key : null,
    values: {
      type: 'courseAccess',
      courseId,
      userId,
      data
    }
  });
};
